import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import { useToast } from './ToastHook.js';
import { ToastContextProvider } from './ToastContext.js';

const ToastProvider = (props) => (jsxRuntimeExports.jsx(ToastContextProvider, { ...props, value: useToast() }));

export { ToastProvider as default };
//# sourceMappingURL=ToastProvider.js.map
